import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../Image';

export const CtaWrapper = styled.div`
  display: ${({ hideFrench }) => (hideFrench ? 'none' : 'flex')};
  flex-direction: column;
  margin: 2rem 0rem 0rem;
  gap: 1.5rem;
  align-items: center;

  @media only screen and (min-width: 424px) {
    display: ${({ hideFrench }) => (hideFrench ? 'none' : 'inline-flex')};
  }

  &.start {
    align-items: start;
  }

  &.center-center-left,
  &.center-left,
  &.center {
    a {
      margin: 0rem auto;
    }
  }

  &.social-media {
    display: flex;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 2rem 0 0;
    flex-direction: ${({ direction }) => direction};

    &.center {
      margin: 2rem auto;
    }

    &.center-left {
      a {
        margin: 0;
        margin-right: 2rem;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.center-center-left {
      a {
        margin: 0;
        margin-right: 2rem;
      }
    }
  }
`;

export const StyledButton = styled.button`
  border-radius: 28px;
  background-color: ${themeGet('colors.pc-red', '#E1251B')};
  padding: 0.5rem 1.25rem;
  color: ${themeGet('colors.white', '#FFFFFF')};
  line-height: 1.25rem;
  font-size: 1rem;

  &:hover,
  :focus {
    text-decoration: underline;
  }
`;

export const StyledImage = styled(Image)`
  height: 48px;
  width: 100%;
`;
